import { Recipe } from '../../types/fam-graphql'
import Router from '../../routes/router'
import routes from '../../routes/definitions'

export const recipeTagsTransformer = (
  recipe: Recipe | null,
  isOffline?: boolean
) => {
  const generateTagRoutes = (tag: { name: string }) => {
    return Router.getRouteConfig(routes.recipesByTag.name, {
      tag: tag.name,
    })
  }

  return {
    tagsProps: {
      tags: recipe?.tags?.map((tag) => ({
        text: tag?.name ?? '',
        href: tag?.name && generateTagRoutes(tag).href,
        nextAs: tag?.name && generateTagRoutes(tag).nextAs,
        disabled: isOffline,
      })),
    },
  }
}
